// extracted by mini-css-extract-plugin
module.exports = {"root":"GqknN9bS","heading":"__7bivQAGs","content":"V3xeE4EY","item":"YLkj7LQ8","buttons":"k7mLCnz4"};